import { useSelector } from "react-redux";
import CxfMonacoEditor from "components/CxfMonacoEditor";

const EditorOptions = {
  minimap: {
    enabled: false
  },
  scrollbar: {
    vertical: "auto"
  },
  renderLineHighlight: "none",
  wordWrap: "on",
  formatOnType: true,
  padding: {
    top: 10
  },
  fontSize: 12,
  lineHeight: 15
};

const EditorInput = ({ fieldValue, language, onChange, options, ...rest }) => {
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  return (
    <div
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
    >
      <CxfMonacoEditor
        {...rest}
        value={fieldValue}
        options={{
          ...EditorOptions,
          ...options,
          domReadOnly: isFlowActive || options?.domReadOnly,
          readOnly: isFlowActive || options?.readOnly
        }}
        language={language}
        onChange={isFlowActive ? undefined : onChange}
      />
    </div>
  );
};

export default EditorInput;
